import { render, staticRenderFns } from "./SchoolsData-cx.vue?vue&type=template&id=314ee860&scoped=true&"
import script from "./SchoolsData-cx.vue?vue&type=script&lang=js&"
export * from "./SchoolsData-cx.vue?vue&type=script&lang=js&"
import style0 from "./SchoolsData-cx.vue?vue&type=style&index=0&id=314ee860&prod&lang=stylus&scoped=true&"
import style1 from "./SchoolsData-cx.vue?vue&type=style&index=1&id=314ee860&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314ee860",
  null
  
)

export default component.exports